import React from 'react'
import AwesomeError, { AwesomeErrorButton } from 'components/Common/AwesomeError'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { connect } from 'react-redux'
import { getSupportContact } from 'selectors/supportContactSelector'
import BodyText from 'components/Luxkit/Typography/BodyText'

interface Props {
  className?: string;
  hasError?: boolean;
  currentContact: App.GeoContacts;
}

function OfferCalendarNotAvailableMessage(props: Props) {
  const { hasError, className, currentContact } = props
  const dispatch = useOfferPageDispatch()

  const onViewPackagesClick = () => {
    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'room' })
  }

  return (
    <AwesomeError
      title={hasError ? 'Oh no, an error occurred' : 'No dates available'}
      className={className}
    >
      <BodyText variant="large">
        {hasError && 'Our team are working on fixing it now.'}
        {!hasError && 'Unfortunately this room has sold out.'}
        {' '}
        Try selecting another room type or give our customer support team a call on{' '}
        <a
            href={`tel:${currentContact.local.number}`}
            rel="nofollow">{currentContact.local.humanReadable}
        </a>.
      </BodyText>
      <AwesomeErrorButton onClick={onViewPackagesClick}>
        View other rooms
      </AwesomeErrorButton>
    </AwesomeError>
  )
}

function mapStateToProps(state: App.State) {
  return {
    currentContact: getSupportContact(state),
  }
}

export default connect(mapStateToProps)(React.memo(OfferCalendarNotAvailableMessage))
